// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoticeCardSummary_wrapper__2webV","title-text":"NoticeCardSummary_title-text__3yoiu","sub-title-text":"NoticeCardSummary_sub-title-text__3P_AS"};